import React, { useState } from 'react';
import './Settings.css';

const Settings = () => {
  const [settings, setSettings] = useState({
    email: localStorage.getItem('userEmail') || '',
    company: 'Your Company',
    plan: localStorage.getItem('userPlan') || 'basic',
    notifications: true
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings({
      ...settings,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSave = () => {
    // TODO: Save to API
    alert('Settings saved successfully!');
  };

  return (
    <div className="settings-page">
      <h2>Settings</h2>
      <div className="settings-card">
        <h3>Account Information</h3>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={settings.email}
            onChange={handleChange}
            disabled
          />
        </div>
        <div className="form-group">
          <label>Company Name</label>
          <input
            type="text"
            name="company"
            value={settings.company}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Current Plan</label>
          <input
            type="text"
            value={settings.plan.toUpperCase()}
            disabled
          />
          <small>Upgrade your plan from the pricing page</small>
        </div>
      </div>
      <div className="settings-card">
        <h3>Preferences</h3>
        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              name="notifications"
              checked={settings.notifications}
              onChange={handleChange}
            />
            <span>Email notifications</span>
          </label>
        </div>
      </div>
      <button onClick={handleSave} className="btn btn-primary">Save Settings</button>
    </div>
  );
};

export default Settings;
